import { useState, useEffect } from "react";
import { useAzureFileDownload } from "./useAzureFileDownload";

export type ImageSize = "860" | "default" | "full";

// TODO: This needs to use an object for better readability and have default values
// Example usage:
// const { url: fullImageUrl } = useAzureImageDownload(uuid, {
// imageSize: "full",
//  defaultUrl: ""
// });

//  Example definition:
// export interface UseAzureImageDownloadOptions {
// 	defaultUrl?: string;
// 	imageSize?: ImageSize;
// }
// export const useAzureImageDownload = (
// 	uuid?: string | null,
// 	options?: UseAzureImageDownloadOptions
// ) => {
// 	const downloadType = "image";
// 	const defaultUrl = options?.defaultUrl ?? "";
// 	const imageSize = options?.imageSize ?? "default";
// };

export const useAzureImageDownload = (
	downloadType: string,
	defaultUrl?: string,
	uuid?: string,
	imageProfile?: ImageProfile,
	imageSize: ImageSize = "default"
) => {
	const [url, setUrl] = useState<string | undefined>(defaultUrl);

	const { data, error, isLoading } = useAzureFileDownload(
		downloadType,
		uuid,
		imageProfile
	);

	useEffect(() => {
		if (!data) return;

		if (data[imageSize]) {
			setUrl(data[imageSize]);
		}
	}, [data]);

	useEffect(() => {
		if (data) return;

		setUrl(defaultUrl);
	}, [defaultUrl]);

	return {
		url,
		isLoading,
		error
	};
};
